// React i hooks

// API servisi
// import { getDocumentAPI } from "services/api/settings/api";
// import { DocumentDetailFormValues } from "services/api/settings/types";


// Tipovi i konstante
import { DocumentDetailPageCmp, DocumentDetailPageProps } from "./types";
import { SETTING_DETAIL_PAGE_TITLE, SETTING_DOCUMENT_DETAIL_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { BreadcrumbItem } from "ui/components/Breadcrumb/types";

// UI komponente
import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";

// import TabMenu from "../components/TabMenu/TabMenu";

// Moduli specifični za projekt
import { Routes } from "ui/modules/settings/navigation";
import TabMenu from "ui/modules/settings/pages/tenant/components/TabMenu/TabMenu";
import { getActiveUser } from "services/api/users";
import { useSelector } from "react-redux";
import DocumentDetailCard from "./components/DocumentDetailCard/DocumentDetailCard";

const DocumentDetailPage: DocumentDetailPageCmp = (
  props: DocumentDetailPageProps
) => {
  const { user } = useSelector(getActiveUser);




  const title = SETTING_DETAIL_PAGE_TITLE;


  const breadcrumbs: BreadcrumbItem[] = [
    { text: SETTING_DOCUMENT_DETAIL_PAGE_TITLE.text, route: SETTING_DOCUMENT_DETAIL_PAGE_TITLE.route },
  ];

  if (!user) return <></>;

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <PageHeader>
            <PageTitle
              title={`${title.text}`}
              icon={title.icon}
              iconColor={title.iconColor}
            />
            <Breadcrumb items={breadcrumbs} />
          </PageHeader>
          <TabMenu />
        </div>
        <div className="px-4 py-4">
          <DocumentDetailCard  />
        </div>
      </div>
    </>
  );
};

DocumentDetailPage.route = Routes.DocumentDetailPageRouter;

export default DocumentDetailPage;
